import {
  LOAD_MASTERDATA_SAMPLE_IMAGE,
  LOAD_MASTERDATA_SAMPLE_IMAGE_DETAIL,
  UPDATE_MASTERDATA_SAMPLE_IMAGE,
  REMOVE_LISTS,
} from './actions'
const initialState = {
  Lists: [],
  SampleData: '',
  total: 1,
  loading: false,
  draw: -1,
  check: true,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_MASTERDATA_SAMPLE_IMAGE.REQUEST:
      const { loading } = action.payload.data
      return {
        ...state,
        loading: loading,
      }

    case LOAD_MASTERDATA_SAMPLE_IMAGE.SUCCESS:
      const { page } = action.payload
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10
      }
      return {
        ...state,
        Lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case LOAD_MASTERDATA_SAMPLE_IMAGE_DETAIL.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case LOAD_MASTERDATA_SAMPLE_IMAGE_DETAIL.SUCCESS:
      return {
        ...state,
        SampleData: action.payload.lists.data,
        loading: false,
        check1: false,
      }

    case UPDATE_MASTERDATA_SAMPLE_IMAGE.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case UPDATE_MASTERDATA_SAMPLE_IMAGE.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}
